import CourseImportOptionsDialog from 'components/CourseDashboard/CourseImportOptionsDialog';
import FilterDrawer from 'components/CourseDashboard/FilterDrawer';
import SelectCourseDialog from 'components/CourseDashboard/SelectCourseDialog';
import { useAuth } from 'contexts/auth';
import { useJoyride } from 'contexts/joyride';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CourseDashboard/desktop';
import Mobile from 'pages/CourseDashboard/mobile';
import { PageContext } from 'pages/CourseDashboard/PageProvider';
import Tablet from 'pages/CourseDashboard/tablet';
import { useContext, useEffect, useState } from 'react';
import { Drawer } from 'shell/components';

const PageLayout = () => {
    const { selectAccount, startCourseSetup } = useAuth();
    const { setJoyridePaused } = useJoyride();
    const { device } = useViewport();

    const {
        loading,
        createCourseLoading,
        courses,
        selectCourseDialog,
        setSelectCourseDialog,
        showImportCourseDialog,
        setShowImportCourseDialog,
        fetchedCourses,
        menuErrors,
        formError,
        handleImportCourse,
        selectImportFromList,
        selectImportById,
        handleSelectCourse,
        handleCourseCardDropdown,
        coursesInView,
        viewArchived,
        setViewArchived,
        courseLobbyLayout,
        setCourseLobbyLayout,
        has_instructor,
    } = useContext(PageContext);

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const [sortKey, setSortKey] = useState('titlea-z');
    const [searchBarInput, setSearchBarInput] = useState('');

    const onChangeSearchBarInput = (value) => {
        if (value === '' || !value) {
            setSearchBarInput('');
        } else {
            setSearchBarInput(value);
        }
    };

    const handleFilterClick = (key, data) => {
        switch (key) {
            case 'SORT': {
                return setSortKey(data);
            }
            default:
                return;
        }
    };

    const handleResetFilterSort = () => {
        setSortKey('titlea-z');
    };

    const getSortedFilteredcourses = () => {
        return coursesInView
            ?.filter((course) => {
                if (searchBarInput) {
                    return course.name?.toLowerCase().includes(searchBarInput.toLowerCase());
                }
                return true;
            })
            .sort((a, b) => {
                if (sortKey === 'titlea-z') {
                    return a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1;
                }
                if (sortKey === 'titlez-a') {
                    return a.name?.toLowerCase() < b.name?.toLowerCase() ? 1 : -1;
                }

                return 0;
            });
    };

    useEffect(() => {
        return () => setJoyridePaused(true);
    }, [setJoyridePaused]);

    const props = {
        loading,
        courses,
        filteredCourses: getSortedFilteredcourses(),
        startCourseSetup,
        searchBarInput,
        has_instructor,
        onChangeSearchBarInput,
        setIsFilterDrawerOpen,
        selectCourse: (course) => selectAccount(course.owner_account_id, course),
        handleImportCourse,
        handleCourseCardDropdown,
        viewArchived,
        setViewArchived,
        courseLobbyLayout,
        setCourseLobbyLayout,
        hasCoursesInView: !!coursesInView?.length,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    const filterDrawerProps = {
        open: isFilterDrawerOpen,
        onClose: () => setIsFilterDrawerOpen(false),
    };

    const FilterDrawerInner = (
        <FilterDrawer
            sortKey={sortKey}
            onClick={handleFilterClick}
            onClose={() => setIsFilterDrawerOpen(false)}
            resetFilterSort={handleResetFilterSort}
        />
    );

    const renderResponsiveFilterDrawers = (device) => {
        return {
            mobile: (
                <Drawer anchor={'left'} device={'mobile'} {...filterDrawerProps}>
                    {FilterDrawerInner}
                </Drawer>
            ),
            tablet: (
                <Drawer anchor={'left'} device={'tablet'} {...filterDrawerProps}>
                    {FilterDrawerInner}
                </Drawer>
            ),
            desktop: (
                <Drawer anchor={'left'} device={'tablet'} {...filterDrawerProps}>
                    {FilterDrawerInner}
                </Drawer>
            ),
        }[device];
    };

    return (
        <>
            {renderResponsiveLayout(device)}
            {renderResponsiveFilterDrawers(device)}

            <CourseImportOptionsDialog
                open={showImportCourseDialog}
                onClose={() => setShowImportCourseDialog(false)}
                onSelectFromList={selectImportFromList}
                onImportById={selectImportById}
                error={menuErrors}
            />
            <SelectCourseDialog
                open={selectCourseDialog.open}
                importType={selectCourseDialog.importType}
                createCourseLoading={createCourseLoading}
                options={fetchedCourses}
                onSave={handleSelectCourse}
                onClose={() => setSelectCourseDialog((prev) => ({ ...prev, open: false }))}
                errors={formError}
            />
        </>
    );
};

export default PageLayout;
